import React, { useState } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { Lock, AlertCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const B2BLoginPage = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    partner_id: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/b2b/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(credentials)
      });

      const data = await response.json();

      if (response.ok) {
        // Store token in sessionStorage (more secure than localStorage)
        // Session expires when browser is closed
        sessionStorage.setItem('b2b_token', data.token);
        sessionStorage.setItem('b2b_partner_id', data.partner_id);
        sessionStorage.setItem('b2b_company', data.company_name);
        sessionStorage.setItem('b2b_token_expiry', Date.now() + (24 * 60 * 60 * 1000)); // 24 hours
        
        // Redirect to portal
        navigate('/b2b/portal');
      } else {
        setError(data.detail || 'Login failed. Please check your credentials.');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Network error. Please check your connection and try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Navigation />
      
      <section style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
        background: 'var(--bg-secondary)'
      }}>
        <div style={{ maxWidth: '450px', width: '100%' }}>
          <div style={{
            background: 'var(--bg-primary)',
            padding: '40px',
            borderRadius: 0,
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
          }}>
            <div style={{ textAlign: 'center', marginBottom: '32px' }}>
              <Lock size={48} style={{ margin: '0 auto 16px', color: 'var(--text-primary)' }} />
              <h1 className="hero-medium" style={{ marginBottom: '8px' }}>
                B2B Agent Login
              </h1>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Access your exclusive partner portal
              </p>
            </div>

            {error && (
              <div style={{
                background: '#f8d7da',
                border: '1px solid #f5c6cb',
                color: '#721c24',
                padding: '16px',
                marginBottom: '24px',
                borderRadius: 0,
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
              }}>
                <AlertCircle size={20} />
                <span>{error}</span>
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '20px' }}>
                <label className="body-regular" style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>
                  Partner ID or Email
                </label>
                <input
                  type="text"
                  name="partner_id"
                  value={credentials.partner_id}
                  onChange={handleChange}
                  required
                  placeholder="Enter your Partner ID or email"
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '1px solid var(--border-medium)',
                    borderRadius: 0,
                    fontSize: '14px'
                  }}
                />
              </div>

              <div style={{ marginBottom: '24px' }}>
                <label className="body-regular" style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>
                  Password
                </label>
                <input
                  type="password"
                  name="password"
                  value={credentials.password}
                  onChange={handleChange}
                  required
                  placeholder="Enter your password"
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '1px solid var(--border-medium)',
                    borderRadius: 0,
                    fontSize: '14px'
                  }}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="btn-primary"
                style={{
                  width: '100%',
                  padding: '14px',
                  fontSize: '16px',
                  opacity: loading ? 0.6 : 1,
                  cursor: loading ? 'not-allowed' : 'pointer'
                }}
              >
                {loading ? 'Logging in...' : 'Login to Portal'}
              </button>
            </form>

            <div style={{
              marginTop: '24px',
              paddingTop: '24px',
              borderTop: '1px solid var(--border-light)',
              textAlign: 'center'
            }}>
              <p className="body-small" style={{ color: 'var(--text-secondary)', marginBottom: '8px' }}>
                Don&apos;t have an account?
              </p>
              <a href="/b2b/register" style={{
                color: 'var(--text-primary)',
                textDecoration: 'underline',
                fontSize: '14px'
              }}>
                Register as Travel Partner
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};
